import { RepairRequestState } from '@wm-front/admin/graphql'
// eslint-disable-next-line @nx/enforce-module-boundaries
import { RepairRequestStatePipe } from '@wm-front/shared/pipes'

export function translateRepairRequestState(state: RepairRequestState): string {
  return new RepairRequestStatePipe().transform(state)
}
